export default function Icon({
  icon: IconComponent,
  size = 20,
  className = '',
  style = {},
  ...props
}) {
  if (!IconComponent) {
    console.warn('Icon component is not provided.');
    return null;
  }

  // Merge the incoming style with the default color set to currentColor.
  const mergedStyle = {
    color: 'currentColor',
    ...style,
  };

  return (
    <IconComponent
      size={size}
      className={className}
      style={mergedStyle}
      {...props}
    />
  );
}
